import React from 'react'
import SEO from '../../seo/SEO'
import OurJourney_Banner from './OurJourney_Banner/OurJourney_Banner'
import OurJourneyTimeline from './OurJourneyTimeline/OurJourneyTimeline'

const OurJourney = () => {
  return (
      <>
      <SEO />
    <div>
        <OurJourney_Banner/>
        <OurJourneyTimeline/>
    </div>
    </>
  )
}

export default OurJourney
